import { render, staticRenderFns } from "./Updaterquirement.vue?vue&type=template&id=77bfa843&scoped=true&"
import script from "./Updaterquirement.vue?vue&type=script&lang=js&"
export * from "./Updaterquirement.vue?vue&type=script&lang=js&"
import style0 from "./Updaterquirement.vue?vue&type=style&index=0&id=77bfa843&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bfa843",
  null
  
)

export default component.exports